import React from "react";
import { Grid, TextField } from "@mui/material";

const TextFieldPA = ({label, value, ...otherProps }) => {

  const configTextField = {
    ...otherProps,
    fullWidth: true,
    variant: "outlined",
    size: "small",
    disabled: true,
    value: value ?? ""
  };

  return (
    <Grid
      item
      xs
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        marginTop: "16px",
      }}
    >
      <p>{label}</p>
      <TextField {...configTextField} />
    </Grid>
  );
};

export default TextFieldPA;
